<template>
  <div>
    <header-slot>
      <template #content-right>
        <b-button
          @click="$refs['empresas-table'].toggleModal()"
          variant="outline-success"
        >
          NUEVO
        </b-button>
      </template>
    </header-slot>
    <b-card
      no-body
      class="border-top-primary border-3 border-table-radius px-0"
    >
      <EmpresasTable ref="empresas-table" />
    </b-card>
  </div>
</template>

<script>
import EmpresasTable from "@/views/settings/views/empresas/components/EmpresasTable.vue";

export default {
  components: {
    EmpresasTable,
  },
};
</script>